// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__32Y0_","module-menu-enter":"Tooltip_module-menu-enter__1JuX9"};